import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { messages as m } from '../../../constants';
import * as D from '../../../deps';
import BackstagePodcastMoreFromCategory from '../../common/BackstagePodcastMoreFromCategory';
import { PodcastProgramRowGridWithLogger } from '../../common/PodcastRowGrid/PodcastProgramRowGrid';

import BackstagePodcastProgramAvailableEpisodeContent from './BackstagePodcastProgramAvailableEpisodeContent';
import BackstagePodcastProgramDescription from './BackstagePodcastProgramDescription';
import BackstagePodcastProgramNoEpisodes from './BackstagePodcastProgramNoEpisodes/BackstagePodcastProgramNoEpisodes';

export const BackstagePodcastProgramMainContent = props => {
  const {
    programId,
    description,
    descriptionUrl,
    programTitleUrl,
    similarPodcasts,
    copyrights,
    hasOnlyRetiredContent,
  } = props;

  return (
    <React.Fragment>
      {description && (
        <BackstagePodcastProgramDescription
          description={description}
          descriptionUrl={descriptionUrl}
        />
      )}
      {hasOnlyRetiredContent ? (
        <BackstagePodcastProgramNoEpisodes programId={programId} />
      ) : (
        <BackstagePodcastProgramAvailableEpisodeContent
          programId={programId}
          programTitleUrl={programTitleUrl}
        />
      )}
      {similarPodcasts && !!similarPodcasts.size && (
        <PodcastProgramRowGridWithLogger
          title={<FormattedMessage {...m.similarPodcasts} />}
          elements={similarPodcasts}
        />
      )}
      <BackstagePodcastMoreFromCategory pandoraId={programId} />
      {copyrights && <D.CopyrightWithLogger copyrights={copyrights} />}
    </React.Fragment>
  );
};

BackstagePodcastProgramMainContent.propTypes = {
  programId: PropTypes.string.isRequired,
  programTitleUrl: PropTypes.string,
  description: PropTypes.string,
  descriptionUrl: PropTypes.string,
  similarPodcasts: ImmutablePropTypes.listOf(PropTypes.string),
  copyrights: PropTypes.string,
  hasOnlyRetiredContent: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const { programId } = ownProps;
  const annotation = D.getAnnotationsById(state, programId);
  const catalogDetails = D.getDetails(state, programId);

  const description = D.Utils.Core.getFromMap(catalogDetails, 'summary');
  const programTitleUrl = D.Utils.Core.getFromMap(annotation, 'shareableUrlPath');
  const descriptionUrl = programTitleUrl
    ? D.Utils.Route.getBackstageFullDescriptionPathForShareUrl(programTitleUrl)
    : null;
  const similarPodcasts = D.Utils.Core.getFromMap(catalogDetails, 'similarPodcasts');
  const copyrights = D.Utils.Core.getFromMap(catalogDetails, 'copyright');
  const hasOnlyRetiredContent = D.Utils.Rights.isRetired(annotation);

  return {
    programId,
    description,
    programTitleUrl,
    descriptionUrl,
    similarPodcasts,
    copyrights,
    hasOnlyRetiredContent,
  };
}

export default connect(mapStateToProps)(BackstagePodcastProgramMainContent);
